<template>
    <div class="relative overflow-x-auto hide-scroll-bar" :data-testid="props.dataTestid + '-container'">
        <TsTypography as="h5" append-class="mb-0"><span v-html="props.data.title"></span></TsTypography>
        <NuxtLinkWithLocale class="text-info" v-if="props.data && props.data.link && props.data.link.text" :to="props.data.link.url">{{ props.data.link.text }}</NuxtLinkWithLocale>
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 mt-2" :data-testid="props.dataTestid + '-table'">
            <thead class="text-sm text-gray-700 capitalize bg-idle-white dark:bg-gray-700 dark:text-gray-400" :data-testid="props.dataTestid + '-table-header'">
                <tr>
                    <template v-for="header in props.data.header" :key="header.label">
                        <th scope="col" class="px-6 py-4" v-html="header.label"></th>
                    </template>
                </tr>
            </thead>
            <tbody :data-testid="props.dataTestid + '-table-body'">
                <template v-for="items in props.data.body" :key="JSON.stringify(items)">
                    <tr class="bg-natural-soft-white border-b dark:bg-gray-800 dark:border-gray-700 last:border-b-0">
                        <template v-for="item in items" :key="item">
                            <td class="px-6 py-4">
                                <TsTypography size="sm"><span v-html="item"></span></TsTypography>
                            </td>
                        </template>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script setup lang="ts">
type Props = {
    data: object[];
    dataTestid: string;
}
const props = withDefaults(defineProps<Props>(), {
});
</script>